import { DEFAULT_ACTION_SOURCE } from '../utils/constants';
import { lazyForwardMessage } from 'owa-mail-compose-actions';
import { ClientItem } from 'owa-mail-store';
import { InstrumentationContext } from 'owa-search/lib/types/InstrumentationContext';
import * as React from 'react';
import {
    shouldSuppressServerMarkReadOnReplyOrForward,
    getSelectedTableView,
} from 'owa-mail-list-store';

export default function onForward(
    item: ClientItem,
    instrumentationContext: InstrumentationContext,
    targetWindow: Window
) {
    return (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();

        lazyForwardMessage.importAndExecute(
            {
                ...item.ItemId,
                mailboxInfo: item.MailboxInfo,
            },
            DEFAULT_ACTION_SOURCE,
            [instrumentationContext],
            shouldSuppressServerMarkReadOnReplyOrForward(getSelectedTableView()),
            { targetWindow: targetWindow }
        );
    };
}
